import { render, staticRenderFns } from "./SubscriptionToggle.vue?vue&type=template&id=3c4e97c1&scoped=true"
import script from "./SubscriptionToggle.vue?vue&type=script&lang=js"
export * from "./SubscriptionToggle.vue?vue&type=script&lang=js"
import style0 from "./SubscriptionToggle.vue?vue&type=style&index=0&id=3c4e97c1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c4e97c1",
  null
  
)

export default component.exports